import React from 'react';

import ApiClientsCreateForm from './ApiClientsCreateForm';

export default function ApiClientsCreateModal(props) {
    return (
        <div className="modal fade" id="create-api-client-modal" tabIndex="-1" role="dialog" aria-labelledby="create-api-client-modal" aria-hidden="true">
            <div className="modal-dialog modal-xl" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{$t('New App')}</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={props.onClose}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <ApiClientsCreateForm
                            categories={props.categories}
                            types={props.types}
                            defaultCategory={props.defaultCategory}
                            defaultType={props.defaultType}
                            onClose={props.onClose}
                            onSubmit={props.onSubmit}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
